const RECORD_PROTOTYPE = Object.getPrototypeOf({});

const isRecord = (value: any): value is Record<any, any> => (
  typeof value === 'object' && value !== null && Object.getPrototypeOf(value) === RECORD_PROTOTYPE
);

export default isRecord;
